// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"48d4310d","50":"3be8a502","270":"c2105ea7","558":"c2105ea7","572":"88f0fc30","614":"c2105ea7","641":"c2105ea7","748":"c2105ea7"}[chunkId] + ".chunk.css";
};